var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"size":"xl","button-size":"sm","hide-footer":"","title":_vm.prefix + _vm.title},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('Pessoa-list',{attrs:{"precisaExistirUsuario":_vm.precisaExistirUsuario,"prefix":_vm.prefix},on:{"onDblClickPessoa":_vm.pessoaSelect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }